import React from "react";
import { stackList } from "../../data/ProjectData";

import {
  Image,
  Technologies,
  Tech,
  TechImg,
  TechName,
  ContactWrapper,
} from "./AboutElements";
import ScrollAnimation from "react-animate-on-scroll";

function About() {
  return (
    <>
      <ContactWrapper id="about">
        <div className="Container">
          <div className="SectionTitle">About Me</div>
          <div className="BigCard">
            <ScrollAnimation animateIn="fadeInLeft">
              <Image
                src="profilee.jpg"
                alt="man-svgrepo"
              />
            </ScrollAnimation>
            <div className="AboutBio">
              <ScrollAnimation animateIn="fadeInLeft">
                Hello! My name is <strong>Suraz Nepal</strong>. I'm originally from <strong>Nepal</strong> and have been living in Canada since 2022.I am a Centennial Graduate from Sofware Engineering faculty. During my time here, I have gained immense knowledge on industry skills, languages and have gained a lot of experience dealing with software methodologies. 
              </ScrollAnimation>

              <br /><br />

              <ScrollAnimation animateIn="fadeInLeft">
                I have a very strong passion for problem-solving, which led me to pursue the Engineering program. Despite its challenges, I remained determined and forged lasting friendships that supported me throughout this demanding program.
                Throughout my studies at Centennial College, I had the opportunity to engage in fascinating projects like developing Websites using MERN Stack, dealing with OOP concepts and have excelled in technical skills. Notably, I contributed to the development of the Booklibrary App, Centennial Navigations System, Gym App and more. I have gained recognition from my colleagues, instructors, and friends.
              </ScrollAnimation>

              <br /><br />

              <ScrollAnimation animateIn="fadeInLeft">
                Working collaboratively within group members, has been an incredibly rewarding and a unique experience for me. I am eager to continue exploring exciting projects in the future, with a particular interest in web development, software system designs and cross-platform mobile development.
                <div className="tagline2">
                  I have become confident using the following technologies:
                </div>
              </ScrollAnimation>


              <Technologies>
                {stackList.map((stack, index) => (
                  <ScrollAnimation animateIn="fadeInLeft" key={index}>
                    <Tech key={index} className="tech">
                      <TechImg src={stack.img} alt={stack.name} />
                      <TechName>{stack.name}</TechName>
                    </Tech>
                  </ScrollAnimation>
                ))}
              </Technologies>
            </div>

          </div>
        </div>
      </ContactWrapper>

      <div id="gapFix" style={{ height: "1px", width: "100%", background: "transparent" }} />

    </>
  );
}

export default About;
